module.exports = __webpack_public_path__ + "static/img/partners4.34666ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/partners4.jpg?0219
// module id = UX4D
// module chunks = 0